<template>
  <section id="contact" class="contact-section mtb-50">
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <iframe id="gmap" class="w-100" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCVnZXX1qbIu8Ej7nxKTVP4FFSjKFSUAzM&amp;q=3 Mount Elizabeth, #17-16, Singapore 228510&amp;zoom=15" allowfullscreen=""></iframe>
        <h2 v-if="getLang() == 'id'" class="contact-title pt-50">Untuk Membuat Janji, <span class="color-brand10C-d25">Telpon Kita Atau Email Kita.</span></h2>
        <h2 v-else class="contact-title pt-50">To make an appointment, <span class="color-brand10C-d25">call us or email us.</span></h2>
      </v-flex>
      <v-flex xs12 lg7>
        <v-form id="contactform" class="form-contact contact_form mt-30 mr-50 mt-xs-0 mr-xs-0 p-20 bg-white" @submit.prevent="submit">
          <v-layout row>
            <v-flex xs12 class="form-group">
              <v-text-field class="form-control pr-20" v-model="vmMsgName" :error-messages="nameErrors" :counter="50" label="Name" required @input="$v.vmMsgName.$touch()" @blur="$v.vmMsgName.$touch()"></v-text-field>
            </v-flex><!-- col-sm-6-->
          </v-layout><!-- row-->
          <v-layout row>
            <v-flex xs12 class="form-group">
              <v-text-field class="form-control pr-20" v-model="vmMsgEmail" :error-messages="emailErrors" label="E-mail" required @input="$v.vmMsgEmail.$touch()" @blur="$v.vmMsgEmail.$touch()"></v-text-field>
            </v-flex><!-- col-sm-6-->
          </v-layout><!-- row-->
          <v-layout row>
            <v-flex xs12 class="form-group">
              <v-text-field class="form-control pr-20" v-model="vmMsgPhone" label="Contact No."></v-text-field>
            </v-flex><!-- col-sm-6-->
          </v-layout><!-- row-->
          <v-layout row>
            <v-flex xs12 class="form-group">
              <v-select class="form-control pr-20" :items="Purpose" label="Select your purpose" v-model="vmMsgPurpose" @change="setPurpose"></v-select>
            </v-flex><!-- col-sm-6-->
          </v-layout><!-- row-->
          <v-layout row>
            <v-flex xs12 class="form-group">
              <v-textarea solo auto-grow v-model="vmMsg" :error-messages="msgErrors" :counter="1000" label="Message" required @input="$v.vmMsg.$touch()" @blur="$v.vmMsg.$touch()"></v-textarea>
            </v-flex><!-- col-sm-12-->
          </v-layout><!-- row-->
          <v-layout row>
            <v-flex xs12 class="form-group mb-0 text-right">
              <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" size="invisible" sitekey="6LdOPL8UAAAAAPXySMQakMnJ6By9uaoELVEHdy9F">
                <v-btn flat class="btn_5" color="white" :disabled="btnsubmitting" @click="submit">Send Message</v-btn>
              </vue-recaptcha>
            </v-flex><!-- col-sm-12-->
          </v-layout><!-- row-->
        </v-form>
      </v-flex>
      <v-flex xs12 lg5 class="plr-xs-10">
        <div class="media contact-info mt-30">
          <div class="media-body">
            <h3 style="font-size:1.3em;"><strong v-html="company_name"></strong></h3>
            <h5 v-html="company_address"></h5>
          </div>
        </div>
        <div class="media contact-info">
          <div class="media-body">
            <h3 v-if="getLang() == 'id'"><span class="contact-info__icon"><v-icon>mdi-hospital-building</v-icon></span>Jam Buka</h3>
            <h3 v-else><span class="contact-info__icon"><v-icon>mdi-hospital-building</v-icon></span>Opening Hours</h3>
            <h5 v-html="company_operatinghrs"></h5>
          </div>
        </div>
        <div class="media contact-info">
          <div class="media-body">
            <h3><span class="contact-info__icon"><v-icon>mdi-phone</v-icon></span>Phone</h3>
            <h5>
              Tel no.
              <strong class="hidden-md-and-down" v-html="company_phone"></strong>
              <a :href="'tel:'+company_phone" class="hidden-lg-and-up" style="text-decoration: underline;"><strong v-html="company_phone"></strong></a>
            </h5>
          </div>
        </div>
        <div class="media contact-info">
          <div class="media-body">
            <h3><span class="contact-info__icon"><v-icon>mdi-email</v-icon></span>Email</h3>
            <h5 v-html="company_email"></h5>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    vmMsgName: { required, maxLength: maxLength(50) },
    vmMsgEmail: { required, email },
    vmMsg: { required, maxLength: maxLength(1000) },
  },
  props: {
    language: String,
    displayflex: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      company_name: 'Daniel Wai Diabetes,<br />Thyroid and Hormone Clinic Pte. Ltd.',
      company_address: '3 Mount Elizabeth, #17-16, Singapore 228510',
      company_email: 'info@drdanielwai.com.sg',
      company_phone: '+65 6733 5201',
      company_emergency: '+65 6535 8833',
      company_fax: '+65 3125 7107',
      company_operatinghrs: 'Monday to Friday 8:30am-1:00pm, 2:00pm-5:30pm<br />Saturday 8:30am-1:00pm',
      vmMsgCoName: '',
      vmMsgName: '',
      vmMsgEmail: '',
      vmMsgPhone: '',
      vmMsg: '',
      vmMsgPurpose: '',
      Purpose: [
        'Appointment',
        'Services',
        'Others'
      ],
      btnsubmitting: false,
      msgpkg: {
        coname: '',
        name: '',
        email: '',
        phone: '',
        subject: '',
        msg: '',
        sitekey: ''
      }
    }
  },
  created() {
    let grecapui = document.createElement('script');
    grecapui.setAttribute('src',"https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit");
    grecapui.setAttribute('async','')
    grecapui.setAttribute('defer','')
    document.head.appendChild(grecapui);
  },
  methods: {
    getLang() {
      this.language = this.$cookies.get('whatlang');
      return this.language;
    },
    qPurpose () {
      if (this.$route.query.q) {
        this.vmMsgPurpose = this.$route.query.q;
      } else {
        this.vmMsgPurpose = '';
      }
    },
    setPurpose () {
      if (this.vmMsgPurpose === 'Others' || this.vmMsgPurpose === null || this.vmMsgPurpose === '') {
        this.vmMsg = "";
      } else {
        this.vmMsg = "Hi,\nI am interested on " + this.vmMsgPurpose + ".\n";
      }
    },
    submit () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.set_vsnackbar_Show(true);
        this.set_vsnackbar_Msg('Unable to send. Please fill in the required fields.');
      } else {
        this.btnsubmitting = true;
        this.$refs.recaptcha.execute();
      }
    },
    clear () {
      this.$v.$reset()
      this.vmMsgCoName = ''
      this.vmMsgName = ''
      this.vmMsgEmail = ''
      this.vmMsgPhone = ''
      this.vmMsg = ''
      this.vmMsgPurpose = ''
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.msgpkg.sitekey = recaptchaToken;
      this.msgpkg.coname = this.vmMsgCoName;
      this.msgpkg.name = this.vmMsgName;
      this.msgpkg.email = this.vmMsgEmail;
      this.msgpkg.phone = this.vmMsgPhone;
      this.msgpkg.subject = this.vmMsgPurpose;
      this.msgpkg.msg = this.vmMsg;
      this.post_ContactRecaptcha(this.msgpkg);
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    ...mapActions(['post_ContactRecaptcha', 'reset_ContactPostStatus']),
    ...mapMutations(['set_vsnackbar_Show', 'set_vsnackbar_Msg']),
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.vmMsgName.$dirty) return errors
      !this.$v.vmMsgName.maxLength && errors.push('Name must be at most 50 characters long')
      !this.$v.vmMsgName.required && errors.push('Name is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.vmMsgEmail.$dirty) return errors
      !this.$v.vmMsgEmail.email && errors.push('Must be valid e-mail')
      !this.$v.vmMsgEmail.required && errors.push('E-mail is required')
      return errors
    },
    msgErrors () {
      const errors = []
      if (!this.$v.vmMsg.$dirty) return errors
      !this.$v.vmMsg.maxLength && errors.push('Message must be at most 1000 characters long')
      !this.$v.vmMsg.required && errors.push('Message is required.')
      return errors
    },
    ...mapState({
      contactPostStatus: state => state.contactMod.contactPostStatus,
    })
  },
  mounted() {
  },
  watch: {
    contactPostStatus() {
      if (this.contactPostStatus !=='') {
        this.set_vsnackbar_Show(true);
        this.set_vsnackbar_Msg(this.contactPostStatus);
        this.btnsubmitting = false;
        this.clear();
        this.$refs.recaptcha.reset();
        this.reset_ContactPostStatus();
      }
    },
    '$route.query.q'() {
      this.qPurpose();
    },
    vmMsgPurpose() {
      this.setPurpose();
    }
  },
  components: {
    'vue-recaptcha': VueRecaptcha
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .form-control.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;
  }
  .form-control.v-text-field>.v-input__control>.v-input__slot:after {
    border-style: none;
  }
</style>
